var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCountCard',{attrs:{"value":_vm.publishersStats.publishersTotalCount,"unit":"ناشر فرصة عمل ضمن المنصة"}})}
var staticRenderFns = []

export { render, staticRenderFns }